export default "__VITE_ASSET__xxM1buXt__"